import styled from 'styled-components';
import CtaPrimary from 'components/ui/CtaPrimary';
import { media } from 'helpers/MediaHelper';

export const StyledHeader = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex: 1;
  ${media.largeDesktop`
    margin-bottom: 0;
  `};
`;

export const StyledMain = styled.main`
  background-color: #fafafc;
  margin-top: 53px;
  height: calc(100vh - 53px);
  ${media.mobile`
    margin-top: 0;
    overflow-y: scroll;
  `};
`;

export const StyledHeaderContainer = styled.div`
  padding: 20px 20px 9px;
  display: flex;
  flex-direction: row;
  ${media.desktop`
    justify-content: space-between;
    flex-direction: column;
  `};
  ${media.mobile`
    justify-content: space-between;
    flex-direction: column;
    position: sticky !important;
    top: -82px;
    z-index: 1;
    background: #fafafc;
    padding-top: 70px;
    justify-content: space-between;
    flex-direction: column;
  `};
`;

export const StyledAddButton = styled(CtaPrimary)`
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  padding-top: 1px;
  margin-left: 24px;
  margin-top: 6px;
  font-family: Circular-Bold;
`;

export const StyledTableContainer = styled.div`
  width: 100%;
  ${media.mobile`
    padding-bottom: 50px;
  `};
`;
